import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const AffectedItemsQualityStepConfig: StepConfig = {
    type: FormType.AFFECTED_ITEMS_QUALITY
};
